import { Stack } from '@mui/material';
import React from 'react';

import { TextFieldWrapper, TextAreaRoot } from './text-field-styles';
import { TextFieldError, TextFieldTitle } from './TextFieldTitle';

interface TextAreaComponentProps {
    title?: string;
    required?: boolean;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    minRows?: number;
    errorValue?: string;
    sx?: React.CSSProperties;
    label?: string;
    autoComplete?: string;
}

export const TextAreaComponent: React.FC<TextAreaComponentProps> = ({
    title,
    required = false,
    value,
    onChange,
    placeholder = '',
    minRows = 4,
    errorValue = '',
    sx,
    label,
    autoComplete = 'off',
}) => {
    return (
        <TextFieldWrapper>
            {title && <TextFieldTitle title={title} required={required} />}

            <Stack>
                <TextAreaRoot
                    minRows={minRows}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    autoComplete={autoComplete}
                    sx={sx}
                    {...(label && { label })}
                />
            </Stack>

            {errorValue && <TextFieldError errorValue={errorValue} />}
        </TextFieldWrapper>
    );
};
